import { useEffect, useState } from "react"
import { supabaseGetter } from "~/api/supabase-getter"

export const useUserFarms = ({ user }) => {
  const [userFarms, setUserFarms] = useState()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let isMounted = true

    // based on current user, find the farm org(s) associated with them as the owner.
    async function fetchUserFarm() {
      // guard against super admins, they don't own farms
      if (user?.permissions === 1 || !user) {
        if (isMounted) {
          setLoading(false)
          setUserFarms(null)
        }
        return
      }

      try {
        const { data: userOrgs, error: fetchOrgUserError } = await supabaseGetter.organizationUsers.getByUser(user.id)

        if (!isMounted) return

        const userOrgIds = userOrgs.map(org => org.organization_id)

        const { data, error: fetchOrgError } = await supabaseGetter.organizations.getByIds(userOrgIds)

        if (!isMounted) return

        const fetchError = fetchOrgUserError || fetchOrgError

        if (fetchError) {
          console.warn('Error fetching user farm:', fetchError)
          setError(fetchError.message || 'Failed to fetch user farm')
          setUserFarms()
        } else if (data) {
          setUserFarms(data)
        }
      } catch (err) {
        if (!isMounted) return

        console.warn('Error in fetchUserFarm:', err)
        setError('An unexpected error occurred')
        setUserFarms()
      } finally {
        if (isMounted) {
          setLoading(false)
        }
      }
    }

    fetchUserFarm()

    return () => {
      isMounted = false
    }
  }, [user])

  return {
    userFarms,
    loading,
    error,
    invalidate: () => {
      supabaseGetter.organizationUsers.invalidate()
      supabaseGetter.organizations.invalidate()
    }
  }
}
